export default __webpack_public_path__ + "static/media/HelveticaNeueLT-Roman.e95d886e.ttf";